module.exports = __webpack_public_path__ + "static/img/rank_18.227927e.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/img/rank_18.png
// module id = TmB2
// module chunks = 1